var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow-angle-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4713045,4.73533106e-08 C17.5466475,4.73533106e-08 17.6206931,0.00555486832 17.6930541,0.0162773103 C17.7259564,0.0212575126 17.7593634,0.0273669526 17.7925726,0.0346147994 C17.9202263,0.0623622049 18.0415788,0.106377782 18.1546135,0.164320334 C18.1731308,0.173704908 18.1913055,0.183491043 18.2093148,0.193679309 C18.2334407,0.207468672 18.2572807,0.221858657 18.2806761,0.236880854 C18.297555,0.24757197 18.3140149,0.258612103 18.3302994,0.270013491 C18.3532661,0.286233283 18.3755448,0.302767211 18.3973374,0.319891769 C18.4124621,0.331679116 18.4278989,0.344313265 18.4431378,0.357301738 C18.4653526,0.376277041 18.4868381,0.395668718 18.5077464,0.415659078 C18.5150174,0.422614592 18.521831,0.429259627 18.5285966,0.435982463 L18.5546697,0.46253845 C18.5724186,0.481067696 18.5896968,0.500051424 18.6064852,0.519470424 L18.5285966,0.435982463 C18.5716984,0.478811768 18.6116549,0.523609091 18.6484654,0.570087202 C18.6630021,0.588590679 18.6775157,0.607855477 18.691568,0.627473194 C18.7078224,0.649955699 18.7229762,0.672384496 18.7374577,0.695118937 C18.7485856,0.712830942 18.7596784,0.731079964 18.7703875,0.749578915 C18.7813704,0.768321359 18.7917007,0.787116262 18.8015984,0.806078772 C18.9100164,1.0137894 18.9713045,1.24973742 18.9713045,1.50000005 L18.9713045,17.5728988 C18.9713045,18.4013259 18.2997317,19.0728988 17.4713045,19.0728988 C16.6428774,19.0728988 15.9713045,18.4013259 15.9713045,17.5728988 L15.971,5.137 L2.56401763,18.6301909 C1.98009133,19.2178316 1.03034864,19.2208427 0.44270795,18.6369164 C-0.144932736,18.0529901 -0.147943839,17.1032474 0.435982463,16.5156067 L13.865,3 L1.50000005,3.00000005 C0.72030393,3.00000005 0.0795513692,2.40511196 0.00686662541,1.64446006 L4.73532964e-08,1.50000005 C4.73532964e-08,0.671572923 0.671572923,4.73533106e-08 1.50000005,4.73533106e-08 L17.4713045,4.73533106e-08 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-angle-right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    transform: "translate(2.542547, 2.456660)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#000000",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.542547, -2.456660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAngleRight);
export default __webpack_public_path__ + "static/media/arrow-angle-right.b18b2def9d44da4893d54b5ba1779ab0.svg";
export { ForwardRef as ReactComponent };